import type {
  AaExecuteSyncBatchRequest,
  AaExecuteSyncBatchResponse,
} from '@/pages/AppAnalytics/appAnalyticsBatchTypes';

import { analyticsServiceAxios, fuelToolsApiAxios } from './interceptor';

const FuelAnalyticsService = {
  async post(route: string, data: any) {
    try {
      const fullRoute = `${route}`;
      const res = await fuelToolsApiAxios.post(fullRoute, data);
      return res.data;
    } catch (err) {
      console.error('err', err);
      throw err;
    }
  },

  async executeSyncBatch(request: AaExecuteSyncBatchRequest): Promise<AaExecuteSyncBatchResponse> {
    try {
      const res = await analyticsServiceAxios.post<AaExecuteSyncBatchResponse>('Query/ExecuteSyncBatch', request);
      return res.data;
    } catch (err) {
      console.error('Error executing analytics sync batch:', err);
      throw err;
    }
  },

  async get(route: string, queryParams: any = null) {
    let fullRoute = `${route}`;
    if (queryParams != null) {
      const qs = Object.keys(queryParams)
        .map((key) => `${key}=${queryParams[key]}`)
        .join('&');
      fullRoute += `?${qs}`;
    }
    try {
      const res = await fuelToolsApiAxios.get(fullRoute);
      return res.data;
    } catch (err) {
      console.error('err', err);
      throw err;
    }
  },
};

export default FuelAnalyticsService;
